<template>
  <div class="mt-5 row" v-if="$store.getters.pedidos.length">
    <div class="mx-auto col-12">
      <b-breadcrumb :items="items"></b-breadcrumb>
      <div class="card">
        <div class="card-header">
          <h3>Lista de Pedidos do Paciente</h3>
        </div>
        <div class="card-body">
          <p>
            <strong>Nome do Paciente:</strong>
            {{ $store.getters.nome }}
          </p>
          <p>
            <strong>Número do pedido:</strong>
            {{ $store.getters.nuped }}
          </p>
          <b-table
            hover
            small
            :items="pedidos"
            :fields="fields"
            :busy="isBusy"
            @row-clicked="onRowClicked"
          >
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'NUPED' ? '40%' : '60%' }"
              />
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      classRow: "",
      isBusy: false,
      fields: [
        { key: "NUPED", label: "Número do pedido" },
        { key: "DTPED", label: "Data da coleta" }
      ],
      items: [
        { text: "Busca pedido", to: { name: "home" } },
        { text: "Lista pedidos", active: true }
      ]
    };
  },
  computed: {
    http() {
      return this.$store.getters.http;
    },

    pedidos() {
      let pedidos = this.$store.getters.pedidos.map(pedido => {
        return {
          NUPED: pedido.NUPED,
          DTPED: this.$filter.dateToString(pedido.DTPED)
        };
      });
      return pedidos;
    },
  },
  methods: {
    onRowClicked(item) {
      if (item) {
        this.$store.dispatch("selecionaPedido", item);
        this.$router.push({ name: "lista-exames" });
        }
      }
  },
  mounted() {
    if (!this.$store.getters.pedidos.length) {
      window.location = window.location.protocol+'//'+window.location.host
    }
    this.$store.dispatch("desselecionaPedido")
    this.$store.dispatch("flushMsgs", "msgs")
  }
};
</script>

<style>
.table tbody tr:hover {
  color: white !important;
  background-color: rgba(40, 167, 69, 0.6) !important;
  cursor: pointer;
}
</style>